<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="true" offset-y="offset-y">
      <template v-slot:activator="{ on }">
        <v-card
          flat
          color="transparent"
          class="white--text pointer pl-3 pr-2"
          v-on="on"
          v-if="$vuetify.breakpoint.smAndUp"
        >
          <span class="body-2 font-weight-regular mr-3" v-if="!$vuetify.breakpoint.xsOnly">{{ currentUser.fullName }}</span>
          <v-avatar size="22px">
            <img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" alt="User" />
            <img v-else src="../../../assets/images/user.jpeg" alt="User" />
          </v-avatar>
        </v-card>
        <!-- <v-btn v-on="on" icon large v-if="$vuetify.breakpoint.xsOnly">
          <v-avatar size="22px">
            <img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" alt="User" />
            <img v-else src="../../../assets/images/user.jpeg" alt="User" />
          </v-avatar>
        </v-btn> -->
      </template>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-layout>
                <img
                  class="menu-img"
                  v-if="currentUser.imageUrl"
                  :src="currentUser.imageUrl"
                  alt="User"
                />
                <img class="menu-img" v-else src="../../../assets/images/user.jpeg" alt="User" />
                <v-flex class="ml-2 ">
                  <v-list-item-title>{{ currentUser.fullName }}</v-list-item-title>
                  <v-list-item-subtitle>{{ currentUser.loginEmail }}</v-list-item-subtitle>
                </v-flex>
              </v-layout>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn small color="pink" dark="dark" icon @click="editProfile">
                <v-icon small>mdi-lead-pencil</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-divider> </v-divider>
        <v-card-actions>
          <span>Version: <strong>{{ version }}</strong></span>
          <v-spacer> </v-spacer>
          <v-btn color="primary" text to="/logout">{{ $t("buttons.logout") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import version from "../../../../package.json"
const pjson = require('../../../../package.json');

export default {
  name: "layout-menu",
  data() {
    return {
      fav: true,
      menu: false,
      message: false,
      hints: true
    };
  },
  computed: {
    ...mapGetters("global", ["currentOrganization", "currentUser"]),
     version() {
      return pjson.version;
    },
  },
  methods: {
    editProfile() {
      this.$router.push(`/user/edit/${this.currentUser.userID}`);
    }
  }
};
</script>

<style scoped>
.br-50 {
  border-radius: 50%;
}
.menu-box {
  border: white solid 0.1em;
  padding: 7px;
  border-radius: 4px;
  cursor: pointer;
}
.menu-img {
  border-radius: 4px;
  width: 45px;
  height: 48px;
}
</style>
